import React from "react";
import { Smartphone, Download, ShieldCheck, Zap } from "lucide-react";
import styles from "./index.module.scss";
import { getEnv } from "../../AppConfigs";
import { Icon } from "../../components";

const DownloadAppSection: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.topTag}>
        <Smartphone size={16} />
        <span>Ứng dụng di động</span>
      </div>

      <h2 className={styles.title}>Tải eOffice - VIAGS</h2>
      <p className={styles.description}>Quét mã QR để tải ứng dụng và trải nghiệm làm việc mọi lúc, mọi nơi</p>

      <div className={styles.scanLabel}>
        <div className={styles.scanIconWrapper}>
          <Smartphone size={14} />
        </div>
        <span>Quét mã QR để tải xuống</span>
      </div>

      <div className={styles.cardsWrapper}>
        {/* iOS Card */}
        <div className={styles.card}>
          <img src="/assets/images/eOffice-VIAGS-ios.png" alt="iOS QR" className={styles.qrImage} />
          <a href={getEnv("REACT_APP_IOS_APP_URL")} target="_blank" rel="noreferrer" className={styles.storeLink}>
            <Icon.DownloadIOS />
          </a>
        </div>

        {/* Android Card */}
        <div className={styles.card}>
          <img src="/assets/images/eOffice-VIAGS-android.png" alt="Android QR" className={styles.qrImage} />
          <a href={getEnv("REACT_APP_ANDROID_APP_URL")} target="_blank" rel="noreferrer" className={styles.storeLink}>
            <Icon.DownloadAndroid />
          </a>
        </div>
      </div>

      {/* <div className={styles.featureList}>
        <div className={styles.featureItem}>
          <div className={styles.featureIcon}>
            <Download size={12} />
          </div>
          <span>Tải xuống và cài đặt miễn phí</span>
        </div>
        <div className={styles.featureItem}>
          <div className={styles.featureIcon}>
            <ShieldCheck size={12} />
          </div>
          <span>Bảo mật thông tin tuyệt đối</span>
        </div>
        <div className={styles.featureItem}>
          <div className={styles.featureIcon}>
            <Zap size={12} />
          </div>
          <span>Xử lý nhanh chóng, hiệu quả</span>
        </div>
      </div> */}
    </div>
  );
};

export default DownloadAppSection;
